import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _vm.isCancel
        ? [
            _c("span", {
              staticClass:
                "ui-icon-circle-close club-timeout-expired-icon text-error--text",
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-h5 text--text mt-2 mb-4" }, [
              _vm._v("\n      Запись отменена\n    "),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.doctorPageUrl
              ? _c(
                  VBtn,
                  {
                    attrs: { color: "primary", depressed: "" },
                    on: { click: _setup.handleToSpecialistPage },
                  },
                  [_vm._v("\n      Записаться повторно\n    ")]
                )
              : _vm._e(),
          ]
        : [
            _c("img", {
              staticClass: "d-block mb-4 mx-auto",
              attrs: {
                src: "/static/_v1/pd/icons/ui-kit/club/club-check-close.svg",
                alt: "Иконка крестик",
                width: "72",
                height: "72",
              },
            }),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "text-body-1 text--text mb-4" }, [
              _vm._v(
                "\n      Поэтому в клинике нужно будет оплатить\n      полную стоимость "
              ),
              _c("span", { staticClass: "text-no-wrap" }, [
                _vm._v("приёма — " + _vm._s(_vm.fullPrice)),
              ]),
              _vm._v(".\n    "),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "text-body-2 text-secondary--text mb-4" }, [
      _vm._v("\n      Время ожидания оплаты закончилось."),
      _c("br"),
      _vm._v("\n      Можете записаться к специалисту снова\n    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h1", { staticClass: "text-h5 text--text mb-4" }, [
      _vm._v("\n      Вы записались, но не успели\n      "),
      _c("br"),
      _vm._v("воспользоваться скидкой\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }